import { Component, OnInit } from '@angular/core';
import { AccordionComponent } from "../../../../shared/components/accordion/accordion.component";
import { CheckListService } from '../../../../services/check-list.service';
import { ChecklistResponse } from '../../../../interfaces/checklist.model';
import { ChecklistHelperService } from '../../../../services/checklist.helper.service';
import { NzAlertComponent } from 'ng-zorro-antd/alert';
import { EnrollmentDataService } from '../../../../services/enrollment-data.service';
import { PROVIDER_TYPES } from '../../../../shared/constants/static-data.constants';
import { HealthAssessmentListComponent } from '../../health-assessment-list/health-assessment-list.component';
import { ListService } from '../../../../shared/services/list.service';
import { UserService } from '../../../../services/user.service';
import { SectionsService } from '../../../../services/sections.service';

@Component({
  selector: 'ppl-to-do-list',
  standalone: true,
  imports: [AccordionComponent, NzAlertComponent, HealthAssessmentListComponent],
  templateUrl: './to-do-list.component.html',
  styleUrl: './to-do-list.component.css'
})
export class ToDoListComponent implements OnInit {
  program: any;
  userId?: string | null;
  checkListData: any = [];
  isParticipantFlow = false;
  isProviderFlow = false;
  isPA = false;
  entry: string | null = '';
  prvdrAssociations: any = [];
  associationDetailsData: any = {};
  timesheets: any[] = [];

  constructor(private checkListService: CheckListService,
    private listService: ListService,
    private checklistHelperService: ChecklistHelperService,
    private enrollmentDataService: EnrollmentDataService, private userService: UserService,
    private sectionsService: SectionsService) { }

  ngOnInit(): void {
    const providerType = this.getEnrollmentType();
    if (providerType == 'provider') {
      this.isPA = true;
    }
    this.entry = this.userService.getLeadEntry() ?? '';
    this.program = this.userService.getSelectedProgram();
    this.userId = this.userService.getSelectedLead();
    this.isParticipantFlow = this.entry == 'participantEnrollment';
    this.isProviderFlow = this.entry == 'providerEnrollment';
    this.getChecklist();

    if (this.isParticipantFlow) {
      this.getTimesheetTodoList([{
        "jsonPath": "participantId",
        "value": this.userId,
        "operator": "Equal"
      }]);
    }

    if (!this.isParticipantFlow) {
      this.enrollmentDataService.getParticipantAssocChanged().subscribe(() => {
        this.getAssociationDetails();
      })
    }
  }

  getChecklist() {
    this.checkListService.getChecklist(this.program?.program_code, this.userId || '', this.isParticipantFlow).subscribe((data: any) => {
      if (data.responsedata) {
        const checklist: ChecklistResponse = data.responsedata
        if (checklist && checklist.checkList && checklist.checkList.length > 0) {
          this.checkListData = this.checklistHelperService.buildToDoChecklist(checklist.checkList.filter(e => e.checkListStatus == 'P'), this.isParticipantFlow, true);
        }
      }
    });
  }

  buildRequestPayload(pageName: string, searchParams: []) {
    if (searchParams.length == 0) {
      //handle the error here
      return;
    }

    const payload: any = {
      pageName: pageName,
      programCode: this.program?.program_code,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: '1',
      searchParam: searchParams,
      orderByColumn: [],
      orderBy: [],
    };
    return payload;
  }

  getTimesheetTodoList(filters: any) {
    const processedPayload = this.buildRequestPayload(
      'consumerTodoList',
      filters
    );
    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        this.timesheets = data.responsedata;
      });
  }


  getAssociationDetails() {
    const isParticipant = this.entry === 'participantEnrollment';
    this.enrollmentDataService.getAssociationsDetails(this.program.program_code, this.userId || '', isParticipant).subscribe((response: any) => {
      console.log(response.responsedata);
      const data = response.responsedata;
      if (isParticipant) {
        for (const key in PROVIDER_TYPES) {
          this.associationDetailsData[key] = data[key] || [];
        }
      } else {
        this.prvdrAssociations = data.participantAssociations.filter((e: any) => e.checklistStatus == 'P' && e.associationStatus != 'Disassociated');
        console.log('this.prvdrAssociations', this.prvdrAssociations);
      }
    });
  }

  getEnrollmentType() {
    const enrollTypeString = this.sectionsService.getEnrollmentType();
    const enrollType = enrollTypeString ? enrollTypeString : '';
    let enrollmentType;
    if (enrollType && Array.isArray(enrollType)) {
      if (enrollType.length > 1) {
        if (enrollType.includes('provider')) {
          enrollmentType = ['provider'];
        } else if (enrollType.includes('authRepresentative')) {
          enrollmentType = ['authRepresentative'];
        } else if (enrollType.includes('poa')) {
          enrollmentType = ['poa'];
        } else if (enrollType.includes('legalGuardian')) {
          enrollmentType = ['legalGuardian'];
        }
      } else {
        enrollmentType = enrollType[0];
      }
    } else {
      enrollmentType = null;
    }

    return enrollmentType;
  }
}
